import { useEffect, useState } from 'react';
import { getRequest } from 'utils/request';

type UseCSRFTokenArgs = {
  isAppLoading: boolean;
};

const useCSRFToken = ({ isAppLoading }: UseCSRFTokenArgs) => {
  const [isCSRFReady, setIsCSRFReady] = useState(false);

  useEffect(() => {
    if (isCSRFReady || isAppLoading) return;

    const makeRequest = async () => {
      try {
        await getRequest('/');
      } catch (error) {
        // Don't let a flaky/timed-out CSRF probe block the app or spam Sentry as an unhandled rejection
        console.error('Unable to complete CSRF/session check', error);
      } finally {
        setIsCSRFReady(true);
      }
    };

    makeRequest();
  }, [isCSRFReady, isAppLoading]);

  return { isCSRFReady };
};

export default useCSRFToken;
